import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackCTAClick } from "@/utils/analytics";
import heroImage from "@/assets/hero-yacht-golden-hour.jpg";

export default function HeroSection() {
  return (
    <section
      className="hero-section relative bg-background overflow-hidden"
      style={{ contain: "layout paint" }}
    >
      <div className="container mx-auto px-5 md:px-8 pt-10 md:pt-20 pb-16 md:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Copy column */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <p className="eyebrow mb-5">Private Yacht Valuation · Market Intelligence · 40ft+</p>

            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-foreground leading-[1.05] tracking-tight mb-6">
              Private Yacht Valuation
              <span className="block text-foreground/90">&amp; Market Intelligence</span>
            </h1>

            <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl mb-8">
              Data-backed insights for yacht owners, buyers, and advisors — with optional private
              introductions when you choose to explore next steps.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-6 max-w-md sm:max-w-none">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <Link
                  to="/valuation"
                  onClick={() => trackCTAClick("Hero Request Valuation", "/valuation", "Hero Section")}
                >
                  Request Valuation
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="w-full sm:w-auto">
                <a href="#how-it-works">See How It Works</a>
              </Button>
            </div>

          </div>

          {/* Image column */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative aspect-[16/10] lg:aspect-[5/4] overflow-hidden rounded-md shadow-elegant">
              <img
                src={heroImage}
                alt="Private motor yacht cruising calm coastal water at golden hour"
                className="w-full h-full object-cover"
                width={1920}
                height={1088}
                fetchPriority="high"
              />
              {/* Soft ivory wash on the right edge for editorial feel */}
              <div className="hidden lg:block absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background/40 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 border-t border-border pt-10 md:pt-14">
          {[
            {
              title: "Private Process",
              desc: "Your valuation remains private unless you choose to explore sale or acquisition options.",
            },
            {
              title: "Market Intelligence",
              desc: "We combine structured valuation data, listing signals, regional pricing context, and yacht-specific market factors.",
            },
            {
              title: "Luxury Focus",
              desc: "Purpose-built for yachts 40ft+, including large yachts, semi-custom builds, and limited-production vessels.",
            },
          ].map((item) => (
            <div key={item.title}>
              <p className="eyebrow mb-3">{item.title}</p>
              <p className="text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
